import { StepsModalWizardContextProvider } from '../multi-page-modal/use-multi-page-wizard';
import { MultiPageModal } from '../multi-page-modal/multi-page-modal';
import { StartupPageModal } from './startup-page-modal';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FocusFile } from '../../file-importer/types';
import { FocusImportProvider } from './use-focus-import';

interface ImportDialogProps {
    open: boolean;
    onClose: (isOpen: boolean) => void;
}

const getIdFromURL = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
};

export const ImportDialog: React.FunctionComponent<ImportDialogProps> = (props) => {
    const { open, onClose } = props;
    const [steps, setSteps] = useState<JSX.Element[]>();
    const location = useLocation();
    const activityId = getIdFromURL(location.pathname);
    const [focusFile, setFocusFile] = useState<FocusFile | undefined>(undefined);

    if (steps) {
        return (
            <FocusImportProvider activityId={activityId} setFocusFile={setFocusFile} focusFile={focusFile}>
                <StepsModalWizardContextProvider steps={steps}>
                    <MultiPageModal handleClose={onClose} isOpen={open}></MultiPageModal>
                </StepsModalWizardContextProvider>
            </FocusImportProvider>
        );
    }

    return (
        <FocusImportProvider activityId={activityId} setFocusFile={setFocusFile} focusFile={focusFile}>
            <StepsModalWizardContextProvider steps={[<StartupPageModal key="startup-page" setSteps={setSteps} />]}>
                <MultiPageModal handleClose={onClose} isOpen={open}></MultiPageModal>
            </StepsModalWizardContextProvider>
        </FocusImportProvider>
    );
};
